import { Link } from "react-router-dom";
import { useBranding } from "../lib/branding";

export default function Landing() {
  const branding = useBranding();

  return (
    <div className="min-h-screen bg-[#FDFDFC] dark:bg-[#0a0a0a] text-[#1b1b18] dark:text-[#ededec] flex items-center justify-center px-4">
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row bg-white dark:bg-[#161615] rounded-lg shadow-lg overflow-hidden">
          
          {/* Left: visual panel */}
          <div
            className="w-full lg:w-1/2 relative flex items-center justify-center p-8 bg-gray-100 dark:bg-[#1b1b18]"
            style={{
              backgroundImage: `url('${branding.theme.landing_background_url}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-black/30"></div>
            <div className="relative text-center max-w-md text-white">
              <img
                src={branding.theme.logo_square_url}
                alt={branding.product_name}
                className="h-16 w-16 mx-auto mb-6 drop-shadow rounded-2xl"
              />
              <h1 className="text-3xl font-bold mb-4">
                {branding.theme.landing_headline}
              </h1>
              <p className="text-white/90 leading-relaxed">
                {branding.theme.landing_subcopy}
              </p>
            </div>
          </div>
            {/* Left: brand + actions */}
          <div className="w-full lg:w-1/2 p-8 lg:p-16 flex flex-col justify-center text-center">

            {/* Tabs replaced with simple CTA buttons for mobile-first */}
            <h2 className="text-2xl font-bold mb-6">Welcome</h2>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-8">
              Secure management and trust services with robust compliance.
            </p>

           <div className="mx-auto grid grid-cols-1 sm:grid-cols-3 gap-3 w-full max-w-sm">
          {/* ✅ Log in button */}
          <Link
            to="/login"
            className="inline-flex items-center justify-center rounded-xl bg-blue-600 text-white py-2.5 text-sm font-medium hover:bg-blue-700"
          >
            Log in
          </Link>

          {/* ✅ Register personal */}
          <Link
            to="/register/personal"
            className="inline-flex items-center justify-center rounded-xl border border-gray-300 dark:border-gray-700 py-2.5 text-sm font-medium hover:bg-gray-50 dark:hover:bg-[#0f0f0f]"
          >
            Register Individual
          </Link>

          {/* ✅ Register business */}
          <Link
            to="/register/business"
            className="inline-flex items-center justify-center rounded-xl border border-gray-300 dark:border-gray-700 py-2.5 text-sm font-medium hover:bg-gray-50 dark:hover:bg-[#0f0f0f]"
          >
            Register Business
          </Link>
        </div>


          </div>
            
            
        </div>
      </div>
    </div>
  );
}
